import {
  defaultPersons,
  defaultUser,
  initializePipelinesLoaded,
  initializePipelines,
  users,
  owners,
} from "./utils";

const state = (): any => ({
  countries: {
    default: "",
    countries: {},
  },
  currentOwner: "",
  currentCountry: "",
  flyoutOpenedDefault: false,
  generalMsg: "",

  metrics: {},
  uptime: 99,

  credits: undefined,
  userDataLoaded: false,

  stopWSLoading: false,
  wsErrors: [],
  persons: defaultPersons(),
  showAddPerson: false,
  personsAllSelected: false,
  personSelected: {},
  personsSelected: new Set(),

  personEdited: null,
  personFormPipelineId: "",
  personFormReports: [],
  personFormPreCandidateManual: false,
  // Canonical state for the add-person form. personProperties is the flat
  // top-level person fields (document_id, email, phone, preCandidate, ...);
  // reportSettings is nested per-report settings in raw API shape. See
  // utils/reportSettings.ts for the conversion helpers and the form-view
  // projection PersonForm binds to.
  personProperties: {},
  reportSettings: {},

  pipelinesLoaded: initializePipelinesLoaded(),
  pipelines: initializePipelines(),
  permissions: {
    canDeletePersons: false,
    canManageUsers: false,
    canReloadPersons: false,
    canSwitchOwner: false,
    canEditPersons: true,
    canUseAdvanced: false,
    canCreatePipeline: false,
    canUpdatePipeline: false,
    canDeletePipeline: false,
    canCreatePreCandidate: false,
  },
  isFlyoutOpen: false,
  shouldOpenUserFlyout: false,
  shouldOpenOwnerFlyout: false,
  showPersonFilter: false,
  sidebarOpen: false,

  user: defaultUser(),
  users: users(),
  usersEdited: new Set(),
  usersSelected: new Set(),
  showUserFilterForm: false,
  allowedCountries: [],
  availableRoles: { roles: [] },
  usernames: null,

  owners: owners(),
  ownerEdited: null,
  countrySelected: {},
  userLevel: { level: "", roles_allowed: [] },
  liveCalls: {},
  recentLiveCalls: [],

  locale: null,
});

export default state;

export type RootState = ReturnType<typeof state>;
